import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, NoPreloading } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { BASE_PATH, BASE_PATH_V2 } from 'api-client';
import { addIcons } from 'ionicons';
import {
  homeOutline,
  cardOutline,
  timeOutline,
  menuOutline,
  personCircleOutline,
  personOutline,
  mailOutline,
  keyOutline,
  chevronForwardOutline,
  fingerPrintOutline,
  shieldCheckmarkOutline,
  logOutOutline,
  walletOutline,
  checkmarkCircleOutline,
  checkmarkCircle,
  refreshCircle,
  closeCircle,
  helpCircle,
  businessOutline,
  warningOutline,
  receiptOutline,
  notificationsOutline,
  moonOutline,
  languageOutline,
  downloadOutline,
  trashOutline,
  globeOutline,
  logoTwitter,
  logoInstagram,
  starOutline,
  informationCircleOutline,
  documentTextOutline,
  chatbubbleOutline,
  callOutline,
  bookOutline,
  videocamOutline,
  lockClosedOutline,
  settingsOutline,
  helpCircleOutline,
  eyeOutline,
  eyeOffOutline,
  sunnyOutline,
  phonePortraitOutline,
  schoolOutline,
  alertCircleOutline,
  logoWhatsapp,
  qrCodeOutline,
  idCardOutline,
  shieldOutline,
} from 'ionicons/icons';
import { register as registerSwiper } from 'swiper/element/bundle';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { apiKeyInterceptor } from './app/interceptors/api-key.interceptor';
import { authInterceptor } from './app/public/auth/services/auth.interceptor';
import { environment } from './environments/environment';

// Register Swiper web components (<swiper-container>, <swiper-slide>)
registerSwiper();

// Register Ionic icons
addIcons({
  'home-outline': homeOutline,
  'card-outline': cardOutline,
  'time-outline': timeOutline,
  'menu-outline': menuOutline,
  'person-circle-outline': personCircleOutline,
  'person-outline': personOutline,
  'mail-outline': mailOutline,
  'key-outline': keyOutline,
  'chevron-forward-outline': chevronForwardOutline,
  'finger-print-outline': fingerPrintOutline,
  'shield-checkmark-outline': shieldCheckmarkOutline,
  'log-out-outline': logOutOutline,
  'wallet-outline': walletOutline,
  'checkmark-circle-outline': checkmarkCircleOutline,
  'checkmark-circle': checkmarkCircle,
  'refresh-circle': refreshCircle,
  'close-circle': closeCircle,
  'help-circle': helpCircle,
  'business-outline': businessOutline,
  'warning-outline': warningOutline,
  'receipt-outline': receiptOutline,
  'notifications-outline': notificationsOutline,
  'moon-outline': moonOutline,
  'language-outline': languageOutline,
  'download-outline': downloadOutline,
  'trash-outline': trashOutline,
  'globe-outline': globeOutline,
  'logo-twitter': logoTwitter,
  'logo-instagram': logoInstagram,
  'star-outline': starOutline,
  'information-circle-outline': informationCircleOutline,
  'document-text-outline': documentTextOutline,
  'chatbubble-outline': chatbubbleOutline,
  'call-outline': callOutline,
  'book-outline': bookOutline,
  'videocam-outline': videocamOutline,
  'lock-closed-outline': lockClosedOutline,
  'settings-outline': settingsOutline,
  'help-circle-outline': helpCircleOutline,
  'eye-outline': eyeOutline,
  'eye-off-outline': eyeOffOutline,
  'sunny-outline': sunnyOutline,
  'phone-portrait-outline': phonePortraitOutline,
  'school-outline': schoolOutline,
  'alert-circle-outline': alertCircleOutline,
  'logo-whatsapp': logoWhatsapp,
  'qr-code-outline': qrCodeOutline,
  'id-card-outline': idCardOutline,
  'shield-outline': shieldOutline,
});

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withFetch(), withInterceptors([apiKeyInterceptor, authInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: BASE_PATH, useValue: environment.API_BASE_PATH },
    { provide: BASE_PATH_V2, useValue: environment.API_BASE_PATH },
    provideIonicAngular({ mode: 'ios' }),
    provideRouter(routes, withPreloading(NoPreloading)),
  ],
}).catch((err) => console.error(err));
